import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Paper,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import { Delete as DeleteIcon, Add as AddIcon } from "@mui/icons-material";
import CustomTypography from "../../globalStyles/fonts";

const EdgeEditor = ({ edges, setEdges, nodes }) => {
  const addEdge = () => {
    const newEdge = {
      id: `edge_${Date.now()}`,
      from: "",
      to: "",
      label: "",
      arrows: "to",
      smooth: true,
    };
    setEdges([...edges, newEdge]);
  };

  const updateEdge = (id, field, value) => {
    setEdges(
      edges.map((edge) => (edge.id === id ? { ...edge, [field]: value } : edge))
    );
  };

  const deleteEdge = (id) => {
    setEdges(edges.filter((edge) => edge.id !== id));
  };

  const arrowTypes = [
    { label: "To", value: "to" },
    { label: "From", value: "from" },
    { label: "Both", value: "to;from" },
    { label: "None", value: "" },
  ];

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <CustomTypography variant="h6">Edges / Connections</CustomTypography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={addEdge}
          size="small"
          disabled={nodes.length < 2}
        >
          Add Edge
        </Button>
      </Box>

      <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
        {edges.map((edge, index) => (
          <Paper key={edge.id} sx={{ p: 2, mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="subtitle2">Edge {index + 1}</Typography>
              <IconButton
                size="small"
                color="error"
                onClick={() => deleteEdge(edge.id)}
              >
                <DeleteIcon />
              </IconButton>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>From Node</InputLabel>
                  <Select
                    value={edge.from}
                    label="From Node"
                    onChange={(e) =>
                      updateEdge(edge.id, "from", e.target.value)
                    }
                  >
                    {nodes.map((node) => (
                      <MenuItem key={node.id} value={node.id}>
                        {node.label || node.id}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>To Node</InputLabel>
                  <Select
                    value={edge.to}
                    label="To Node"
                    onChange={(e) => updateEdge(edge.id, "to", e.target.value)}
                  >
                    {nodes.map((node) => (
                      <MenuItem key={node.id} value={node.id}>
                        {node.label || node.id}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Label (Optional)"
                  value={edge.label}
                  onChange={(e) => updateEdge(edge.id, "label", e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Arrow Type</InputLabel>
                  <Select
                    value={edge.arrows}
                    label="Arrow Type"
                    onChange={(e) =>
                      updateEdge(edge.id, "arrows", e.target.value)
                    }
                  >
                    {arrowTypes.map((arrow) => (
                      <MenuItem key={arrow.value} value={arrow.value}>
                        {arrow.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
        ))}

        {edges.length === 0 && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography color="textSecondary">
              {nodes.length < 2
                ? "Add at least 2 nodes before creating edges."
                : 'No edges added yet. Click "Add Edge" to connect nodes.'}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default EdgeEditor;
